module.exports = __webpack_public_path__ + "img/creditcards-h.8d113d4.png";